export default {
  'component.portalVersion.guide.title': 'Welcome to the new navigation',
  'component.portalVersion.guide.start': 'Use the new version',
  'component.portalVersion.guide.classic': 'Switch to classic',
  'component.portalVersion.guide.intro':
    'The new version updates both the navigation and release page. Find your usual features in these sections:',
  'component.portalVersion.guide.release':
    'The release page is now a Release Workbench where you can switch environments, filter release orders, and view release scope, approvals and execution status in one place.',
  'component.portalVersion.guide.transition':
    'Both the new and classic versions are available during the transition so everyone can get familiar with the new version gradually.',
  'component.portalVersion.guide.workbench':
    'Workbench: your workspace, approvals, weekly reports and other daily work.',
  'component.portalVersion.guide.collaboration': 'R&D: requirements, sprints, tasks and testing.',
  'component.portalVersion.guide.delivery':
    'Delivery: release workbench, release calendar, service view and release records.',
  'component.portalVersion.guide.operations':
    'Operations: K8s, technical management and duty schedules.',
  'component.portalVersion.guide.switch':
    'You can return to the classic version at any time using the Classic / New switch at the top of the page.',
  'component.portalVersion.tip': 'Keep the current page and refresh the navigation',
  'component.portalVersion.classic': 'Classic',
  'component.portalVersion.v2': 'New',
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
};
